import { Router } from "@angular/router";
import _ from 'lodash';

export class urlUtility {


  public static addQueryParam(route: Router, params: any) {
    route.navigate([], {
      queryParams: params,
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  public static removeQueryParam(route: Router, param: string ) {
    const obj = {};
    _.set(obj, param, null);
    route.navigate([], {
      queryParams: obj,
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

}
